export default {
    name: 'LandingPageSectionTitle',
    props: {
        imageName: {
            type: String,
            required: true
        },
        imageTitle: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        fontSize: {
            type: String
        }
    }
}